import { errorFromResponse } from '@/lib/apiErrors';
import { Audience } from "@/lib/sessioon.types";

export const socialSignIn = async (token: string, env?: string, envUrl?: string): Promise<any> => {
    try {
        // const response = await fetch(`https://${env ? env : 'stage'}.aaq.live/api/v1/auth/social-signin`, {
        const response = await fetch(`${envUrl ? envUrl : `https://${env === 'dev' ? 'dev' : 'stage'}.aaq.live`}/api/v1/auth/social-signin`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "serviceid": `6703da9fe74a8cc31b2b5bf6`,
                "token": `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();

        // Return the data on success
        return data;

    } catch (error) {
        console.error('ERROR IN SOCIAL SIGNIN API - ', error);
    }
}

export const createRoom = async (token: string, bodyParam: any, env?: string, envUrl?: string): Promise<any> => {
    try {
        const response = await fetch(`${envUrl ? envUrl : `https://${env === 'dev' ? 'dev' : 'stage'}.aaq.live`}/api/v1/broadcast`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "serviceid": `6703da9fe74a8cc31b2b5bf6`,
                "token": `Bearer ${token}`
            },
            body: JSON.stringify(bodyParam)
        });

        if (!response.ok) {
            // Preserve the backend's error code. This previously threw a generic
            // Error and the catch below swallowed it, so a plan-restricted account
            // produced no message at all and the caller hung forever on
            // "Setting up your conversation".
            throw await errorFromResponse(response);
        }

        const data = await response.json();

        // Return the data on success
        return data;

    } catch (error) {
        console.error('ERROR IN createRoom API - ', error);
        // Rethrow so the caller can tell the viewer what happened. Swallowing here
        // is what made the failure silent.
        throw error;
    }
}


export const getCategories = async (token: string, env?: string, envUrl?: string): Promise<any> => {
    try {
        const response = await fetch(`${envUrl ? envUrl : `https://${env === 'dev' ? 'dev' : 'stage'}.aaq.live`}/api/v1/category`, {
            headers: {
                "Content-Type": "application/json",
                "serviceid": `6703da9fe74a8cc31b2b5bf6`,
                "token": `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('ERROR IN GET CATEGORIES API - ', error);
    }
}

export const updateBroadcast = async (token: string, sid: string, bodyParam: any, env?: string, envUrl?: string): Promise<any> => {
    try {
        const response = await fetch(`${envUrl ? envUrl : `https://${env === 'dev' ? 'dev' : 'stage'}.aaq.live`}/api/v1/broadcast/${sid}/session`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "serviceid": `6703da9fe74a8cc31b2b5bf6`,
                "token": `Bearer ${token}`
            },
            body: JSON.stringify(bodyParam)
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('ERROR IN UPDATE BROADCAST API - ', error);
    }
}

export const getAgentById = async (agentId: string, token: string, env?: string, envUrl?: string) => {
    try {
        const response = await fetch(`${envUrl ? envUrl : `https://${env === 'dev' ? 'dev' : 'stage'}.aaq.live`}/api/v1/aiBroadcast/${agentId}`, {
            headers: {
                "Content-Type": "application/json",
                "serviceid": `6703da9fe74a8cc31b2b5bf6`,
                "token": `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('ERROR IN GET AGENT BY ID API - ', error);
    }
}

export const getBroadcasts = async (token: string, env?: string, envUrl?: string) => {
    try {
        const response = await fetch(`${envUrl ? envUrl : `https://${env === 'dev' ? 'dev' : 'stage'}.aaq.live`}/api/v1/sessions`, {
            headers: {
                "Content-Type": "application/json",
                "serviceid": `6703da9fe74a8cc31b2b5bf6`,
                "token": `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('ERROR IN GET AGENT BY ID API - ', error);
    }
}

export const audience = async ({ broadId, roomName, rtcUserId, displayName, userName, avatarURl, role, token }: Audience) => {

    try {

        const bodyParam = {
            broadId: broadId,
            roomName: roomName,
            rtcUserId: rtcUserId,
            displayName: displayName,
            username: userName,
            role: role,
            participantMetadata: {
                avatarUrl: avatarURl,
                displayName: displayName,
                role: role,
            }
        };

        const response = await fetch(`https://stage.aaq.live/api/v1/audience`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "serviceid": `6703da9fe74a8cc31b2b5bf6`,
                "token": `Bearer ${token}`
            },
            body: JSON.stringify(bodyParam)
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;

    } catch (error) {
        console.error('ERROR IN CONNECTING AUDIENCE - ', error);
    }
}